import useData from "@/hooks/useData";
import useQueries from "@/hooks/useQueries";
import { API_URL } from "@/shared/utils/API_URL";
import { buildQuery } from "@/shared/utils/buildQuery";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { pdf } from "@react-pdf/renderer";
import InoviceDetailsReport from "@/views/InvoiceDetails/InoviceDetailsReport";
import { saveAs } from "file-saver";
import { useTranslation } from "react-i18next";


const useInvoiceDetials = () => {

    const { id } = useParams();
    const [searchParams] = useSearchParams('licence_id');
    const { t } = useTranslation();

    const [displayBarcode, setDisplayBarcode] = useState(localStorage.getItem('displayBarcode') === 'true')

    const licence_id = searchParams.get('licence_id') || '';

    const queries = useQueries();

    useEffect(() => {
        if (licence_id) {
            localStorage.setItem('licence_id', licence_id);
        }
    }, [licence_id]);

    const invoiceDetailsQuery = queries
        ? buildQuery(queries?.invoiceDetailsQuery, { invoice_id: id })
        : '';
    const { fetchedData, loading } = useData({
        apiUrl: API_URL,
        q: invoiceDetailsQuery,
        t: "sel",
        dependency: [invoiceDetailsQuery, id],
    });

    const invoice = fetchedData?.data?.result || [];
    const total = invoice?.reduce((sum, item) => {
        const price = Number(item?.item_price) || 0;
        const qty = Number(item?.item_quantity) || 0
        return sum + (price * qty)
    }, 0);


    const handleToggleBarcode = () => {
        const newValue = !displayBarcode;
        setDisplayBarcode(newValue);
        localStorage.setItem('displayBarcode', JSON.stringify(newValue))
    }

    const handleExportPdf = async () => {
        const date = new Date().toLocaleString('sv-SE').split(" ")[0];

        try {
            const blob = await pdf(
                <InoviceDetailsReport
                    invoice={invoice}
                    total={total}
                    t={t} />
            ).toBlob();
            saveAs(blob, `Invoice_${date}.pdf`)
        } catch (error) {
            console.log(error);
        }
    }
    return {
        invoiceDetailsQuery,
        loading,
        invoice,
        total,
        displayBarcode,
        handleToggleBarcode,
        handleExportPdf
    }
}

export default useInvoiceDetials;